export enum Team {
	DivokejTurnoff = "DivokejTurnoff",
	OcelovaSmecka = "OcelovaSmecka",
	PHOlomoc = "PHOlomoc",
	PohoranstiVidlaci = "PohoranstiVidlaci",
	PraHaHa = "PraHaHa",
	Other = "Other",
}
